<template >
<div>
<NavBar id="topNav" class="container" ref="NavBar" 
  showLogo="true" showRules="true" 
  showHome="true"  showDealerTut="true"
  @goHome="$parent.toHome()" :language="language"/>
    <b-container >
      
      <div class="text-center">
      <div>
        <b-col class="card-col">
          <img v-if="language === 'english'" src="../assets/images/tap_deck_header.png" style="width: 50%;" alt="" >
          <img v-else-if="language === 'spanish'" src="../assets/images/tap_deck_header_spanish.png" style="width: 50%;" alt="" >
        </b-col>
      </div>
      <div>
        <b-col class="card-col">
          <img src="../assets/cards/back.jpg" style="width: 42%;" alt="" @click="onCardClicked">
        </b-col>
      </div>

      <div>
        <b-col class="card-col">
          <img :src="setCard(this.current_card)" style="width: 42%;" alt="" >
        </b-col>
      </div>
      </div>
      <NavBar id="bottomNav" ref="NavBar" 
          showDealerTut="false" showRecentCards="true" 
          showResetTwo="true" @resetBoard="resetDeck" :language="language"
          @showRecentCards="$bvModal.show('card-history-modal')"/>

  </b-container>
  <b-modal id="card-history-modal" size="xl" hide-footer>
    <div class="card-history-container">
      <div v-for="card in shown_cards" v-bind:key="card" class="history-card-container">
        <img :src="setCard(card)" alt="" class="history-card">
      </div>
    </div>
  </b-modal>
</div>

</template>

<script>
import NavBar from './NavBar'

export default {
  name: "DealerScreen",
  props: ['newDeck', 'useNewDeck','language'],
  components: {NavBar},
  destroyed(){
    this.resetDeck();
  },
  data(){
    return{
      output: null,
      selectedVals: [],
      rowCounts: {},
      colCounts: {},
      origin_card_array: [
        0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,
        21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,
        38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53
      ],
      card_deck: [
        0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,
        21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,
        38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53
      ],
      shown_cards: [],
      dealer_deck: [],
      current_card: "empty.png"
    }
  },
  methods: {
    // Set the image for the card of pos
    setCard(index){
      if(typeof index === 'string'){
        return require(`../assets/cards/${index}`)
      }else{
        return require(`../assets/cards/${index}.jpg`)
      }
    },

    resetDeck(){
      this.current_card = "empty.png";
      this.card_deck = this.origin_card_array
      this.shown_cards = []
    },
    
    onCardClicked() {
      if(this.card_deck.length === 0){
        console.log("No Cards Left")
      }else{
        var random_number = this.card_deck[Math.floor(Math.random() * this.card_deck.length)]
        this.current_card = random_number
        var index = this.card_deck.indexOf(random_number);
        if (index > -1) {
          this.card_deck.splice(index, 1);
        }
        this.shown_cards.push(random_number)
      }
    }
  },
};
</script>